import React from 'react';
import StatusBadge from '../../components/ui/StatusBadge';
import { fmtDate } from '../../utils/dateUtils';
import ReportTab from './ReportTab';
import EvidencesTab from './EvidencesTab';

export default function AssemblyDrawer({ ctx }) {
  const {
    drawerAssembly, drawerReport, drawerEvidences,
    drawerTab, setDrawerTab,
    reportForm, setReportForm, reportSaving,
    uploadType, setUploadType,
    uploadFiles, setUploadFiles, uploadSaving,
    fileRef,
    closeDrawer, changeStatus,
    saveDraft, submitReport,
    uploadEvidence, deleteEvidence,
  } = ctx;

  if (!drawerAssembly) return null;

  const isReportLocked = drawerReport?.status === 'submitted';

  function handleCancelAssembly() {
    const reason = window.prompt('Motivo de cancelacion:');
    if (reason == null) return;
    changeStatus(drawerAssembly.id, 'canceled', { cancellationReason: reason });
  }

  return (
    <aside className="drawer">
      <div className="drawer-header">
        <div>
          <h3 className="drawer-title">{drawerAssembly.address}</h3>
          <p className="drawer-sub">
            {fmtDate(drawerAssembly.scheduledDate)} · {drawerAssembly.startTime}–{drawerAssembly.endTime}
          </p>
        </div>
        <button className="btn-icon close-btn" onClick={closeDrawer}>✕</button>
      </div>

      <div className="drawer-status-row">
        <StatusBadge status={drawerAssembly.status} />
        <div className="drawer-actions">
          {drawerAssembly.status !== 'canceled' && drawerAssembly.status !== 'completed' && (
            <button className="btn-sm btn-cancel" onClick={handleCancelAssembly}>
              ✕ Cancelar
            </button>
          )}
        </div>
      </div>

      {drawerAssembly.status === 'canceled' && drawerAssembly.cancellationReason && (
        <p className="info-box">Motivo de cancelacion: {drawerAssembly.cancellationReason}</p>
      )}

      <div className="drawer-tabs">
        <button className={drawerTab === 'report' ? 'active' : ''} onClick={() => setDrawerTab('report')}>
          Informe
        </button>
        <button className={drawerTab === 'evidences' ? 'active' : ''} onClick={() => setDrawerTab('evidences')}>
          Evidencias{' '}
          {drawerEvidences.length > 0 && <span className="badge-count">{drawerEvidences.length}</span>}
        </button>
      </div>

      <div className="drawer-body">
        {drawerTab === 'report' && (
          <ReportTab
            drawerAssembly={drawerAssembly}
            drawerReport={drawerReport}
            drawerEvidences={drawerEvidences}
            isReportLocked={isReportLocked}
            reportForm={reportForm}
            setReportForm={setReportForm}
            reportSaving={reportSaving}
            onSaveDraft={saveDraft}
            onSubmitReport={submitReport}
            setDrawerTab={setDrawerTab}
          />
        )}
        {drawerTab === 'evidences' && (
          <EvidencesTab
            drawerReport={drawerReport}
            isReportLocked={isReportLocked}
            drawerEvidences={drawerEvidences}
            uploadType={uploadType}
            setUploadType={setUploadType}
            uploadFiles={uploadFiles}
            setUploadFiles={setUploadFiles}
            uploadSaving={uploadSaving}
            fileRef={fileRef}
            onUpload={uploadEvidence}
            onDeleteEvidence={deleteEvidence}
          />
        )}
      </div>
    </aside>
  );
}
